import { render, staticRenderFns } from "./stcokGoods.vue?vue&type=template&id=199b4722&scoped=true&"
import script from "./stcokGoods.vue?vue&type=script&lang=js&"
export * from "./stcokGoods.vue?vue&type=script&lang=js&"
import style0 from "./stcokGoods.vue?vue&type=style&index=0&id=199b4722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b4722",
  null
  
)

export default component.exports